<ng-container
  *ngIf="{
    request: requestCheckInventory$ | async,
    isLogged: isLogged$ | async,
    warehouses: warehouses$ | async,
  } as content"
>
  @if (content.isLogged) {
    @if (!content.request?.isLoading) {
      @if (!content.request?.hasError) {
        @if (content.warehouses?.length) {
          <form>
            <div class="box-content">
              <table class="table-responsive table-md">
                <thead>
                  <tr>
                    @if (data.hasRadioOptions) {
                      <th class="col-options"></th>
                    }
                    <th>{{ 'inventory.table.header.warehouse' | cxTranslate }}</th>
                    <th>{{ 'inventory.table.header.qty' | cxTranslate }}</th>
                    <th>{{ 'inventory.table.header.estShipDate' | cxTranslate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let warehouse of content.warehouses">
                    @if (data.hasRadioOptions) {
                      <td class="col-options">
                        <span class="responsive-title"> {{ 'inventory.table.header.warehouse' | cxTranslate }}: </span>

                        <div class="content d-flex justify-content-center">
                          <div class="form-group m-0">
                            <label for="">
                              <div class="form-check m-0">
                                <input
                                  id="subscriptiontype-x"
                                  class="form-check-input"
                                  role="radio"
                                  type="radio"
                                  aria-checked="true"
                                  [value]="'x'"
                                  name="warehouse"
                                  (click)="selectWarehouse(warehouse)"
                                  [checked]="currentWarehouse?.warehouseCode === warehouse.warehouseCode"
                                />
                              </div>
                            </label>
                          </div>
                        </div>
                      </td>
                    }

                    <td>
                      <span class="responsive-title"> {{ 'inventory.table.header.warehouse' | cxTranslate }}: </span>

                      @if (data.hasRadioOptions) {
                        <button type="button" class="btn-warehouse-name" (click)="selectWarehouse(warehouse)">
                          {{ warehouse.warehouseName }}
                          <span *ngIf="warehouse.isDefault" class="default-warehouse">{{
                            'inventory.table.header.default' | cxTranslate
                          }}</span>
                        </button>
                      } @else {
                        {{ warehouse.warehouseName }}
                        <span *ngIf="warehouse.isDefault" class="default-warehouse">{{
                          'inventory.table.header.default' | cxTranslate
                        }}</span>
                      }
                    </td>

                    <td>
                      <span class="responsive-title"> {{ 'inventory.table.header.qty' | cxTranslate }}: </span>

                      {{ warehouse.quantity }}
                    </td>

                    <td>
                      <span class="responsive-title"> {{ 'inventory.table.header.estShipDate' | cxTranslate }}: </span>

                      {{ warehouse.shipDate | cxDate: 'MM/dd/yyyy' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>

          @if (data.hasRadioOptions && data.selectWarehouse) {
            <div class="modal-actions">
              <button class="btn btn-outline-primary" (click)="close()">{{ 'generic.cancel' | cxTranslate }}</button>

              <button class="btn btn-primary" (click)="select()">{{ 'generic.select' | cxTranslate }}</button>
            </div>
          }
        } @else {
          <p class="text-center m-0">{{ 'inventory.noContent' | cxTranslate }}</p>
        }
      } @else {
        <alert [alert]="errorMessage"></alert>
      }
    } @else {
      <local-loader></local-loader>
    }
  } @else {
    <div class="w-100 text-center">
      <a [routerLink]="['/login']"> {{ 'inventory.requiredLogin' | cxTranslate }},</a> {{ 'inventory.complementText' | cxTranslate }}
    </div>
  }
</ng-container>
